
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/organizers/[organizerId]",
      function () {
        return require("private-next-pages/organizers/[organizerId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/organizers/[organizerId]"])
      });
    }
  